export enum ButtonAction {
  EDIT,
  DUPLICATE,
  DELETE
}
